const BASE = "https://customer-assets.emergentagent.com/job_qbic-enterprise-hub/artifacts";
const PARTNERS = [
  { id: "intel", name: "Intel", src: "/partners/intel.svg" },
  { id: "dell", name: "Dell Technologies", src: "/partners/dell.png" },
  { id: "lenovo", name: "Lenovo", src: `${BASE}/fmx0zglg_lenovo.png` },
  { id: "redington", name: "Redington", src: `${BASE}/lkp6wags_REDINGTON.png` },
  { id: "ingram", name: "Ingram Micro", src: `${BASE}/4sqiop2u_Ingram%20Micro.png` },
  { id: "sona", name: "Sona Networks", src: "/partners/sona.png" },
];

export const PartnerMarquee = () => (
  <section className="bg-[#F8FAFC] border-b border-slate-200 py-10 overflow-hidden" data-testid="partner-marquee">
    <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-slate-500 mb-8">Our Ecosystem Partners</p>
    <div className="marquee-mask">
      <div className="marquee-track">
        {[...PARTNERS, ...PARTNERS].map((p, i) => (
          <div key={`${p.id}-${i}`} className="flex items-center justify-center h-14 w-44 mx-6 flex-shrink-0" data-testid={i < PARTNERS.length ? `partner-logo-${p.id}` : undefined}>
            <img src={p.src} alt={p.name} className="max-h-12 max-w-full object-contain grayscale opacity-70 transition-[filter,opacity] duration-300 hover:grayscale-0 hover:opacity-100" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  </section>
);
